import React from 'react';
import map from 'lodash/map';

import { Menu, MenuItem } from '@mui/material';
import { usePublicConfig } from '@pv/common/providers';
import { ValidStatuses } from '../../types';

import StatusChip from '../../components/StatusChip';

interface EventStatusDropDownProps {
  status: ValidStatuses;
  setStatus: (status: ValidStatuses) => void;
}
export const EventStatusDropDown = ({
  status,
  setStatus,
}: EventStatusDropDownProps) => {
  const { publicConfig } = usePublicConfig();
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  const clickStatus = (s: ValidStatuses) => () => {
    setStatus(s);
    handleClose();
  };

  const statuses = publicConfig.validEventStatuses;
  return (
    <>
      <StatusChip
        ref={anchorRef}
        id={`event-status-chip`}
        data-cy="event-status-chip"
        status={status}
        onClick={handleClick}
        fullWidth
        size="large"
        aria-controls={isOpen ? 'event-status-chip-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
      />

      <Menu
        id="event-status-chip-menu"
        data-cy="event-status-menu"
        anchorEl={anchorRef.current}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        MenuListProps={{
          'aria-labelledby': 'event-status-chip',
          style: {
            paddingTop: 2,
            paddingBottom: 2,
          },
        }}
        slotProps={{
          paper: {
            style: {
              minWidth: anchorRef.current
                ? anchorRef.current.clientWidth
                : undefined,
              marginTop: 4,
            },
          },
        }}
      >
        {map(statuses, (s) => (
          <MenuItem
            className="event-status-option"
            data-cy="event-status-option"
            onClick={clickStatus(s)}
            key={s}
            selected={s === status}
          >
            <StatusChip status={s} fullWidth size="large"></StatusChip>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default EventStatusDropDown;
